<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>分店管理>添加分店</p>
         <div class="body">
            <p class="storeInfo">*商户信息</p>
            <div class="bodyHead">
                <p><span>商户名称:</span><el-input v-model="input" class="storeName" placeholder="请输入商户名"></el-input></p>
                <div class="block">
                    <span>地址:</span>
                    <el-cascader v-model="value"  class="clickAddress" :options="options" @change="handleChange"></el-cascader>
                </div>
            </div>
            <p><span>详细地址:</span><el-input type="textarea" :rows="2" class="textaddress" placeholder="请输入内容"  v-model="textarea"></el-input></p>
            <p><span>电话区号:</span><el-input v-model="input" class="storeTel" placeholder="请输入商户名"></el-input> <span>联系电话:</span><el-input v-model="input" class="storePhone" placeholder="请输入商户名"></el-input><span class="remark">请输入联系电话、审核时可能需要进行电话核实</span></p>
            <p>
                <span class="storeAptitude">运营资质:</span>
                <el-upload class="avatar-uploader storeImg" action="https://jsonplaceholder.typicode.com/posts/"  :show-file-list="false"  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span class="storeRemark">请上传营业资质证明照片,如营业执照,授权书等、上传图片格式要求:PNG\JPG\无大小限制</span>
            </p>
            <p class="storeInfo">*商户信息</p>
             <p><span>真实姓名:</span><el-input v-model="input" class="storeName" placeholder="请输入商户名"></el-input></p>
              <p><span>电话区号:</span><el-input v-model="input" class="storeTel" placeholder="请输入商户名"></el-input> <span>联系电话:</span><el-input v-model="input" class="storePhone" placeholder="请输入商户名"></el-input><span class="remark">请输入联系电话、审核时可能需要进行电话核实</span></p>
              <el-checkbox class="storeRules" v-model="checked">我同意并遵守《七鸥鸥商家管理系统服务协议》</el-checkbox>
              <el-button class="storeButton" type="primary">提交审核</el-button>
         </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        value: [],
        imageUrl: '',
        options: [{
          value: 'zhinan',
          label: '指南',
          children: [{
            value: 'shejiyuanze',
            label: '设计原则',
            children: [{
              value: 'yizhi',
              label: '一致'
            }, {
              value: 'fankui',
              label: '反馈'
            }, {
              value: 'xiaolv',
              label: '效率'
            }, {
              value: 'kekong',
              label: '可控'
            }]
          }, {
            value: 'daohang',
            label: '导航',
            children: [{
              value: 'cexiangdaohang',
              label: '侧向导航'
            }, {
              value: 'dingbudaohang',
              label: '顶部导航'
            }]
          }]
        }, {
          value: 'zujian',
          label: '组件',
          children: [{
            value: 'basic',
            label: 'Basic',
            children: [{
              value: 'layout',
              label: 'Layout 布局'
            }, {
              value: 'color',
              label: 'Color 色彩'
            }, {
              value: 'typography',
              label: 'Typography 字体'
            }, {
              value: 'icon',
              label: 'Icon 图标'
            }, {
              value: 'button',
              label: 'Button 按钮'
            }]
          }, {
            value: 'form',
            label: 'Form',
            children: [{
              value: 'radio',
              label: 'Radio 单选框'
            }, {
              value: 'checkbox',
              label: 'Checkbox 多选框'
            }, {
              value: 'input',
              label: 'Input 输入框'
            }, {
              value: 'input-number',
              label: 'InputNumber 计数器'
            }, {
              value: 'select',
              label: 'Select 选择器'
            }, {
              value: 'cascader',
              label: 'Cascader 级联选择器'
            }, {
              value: 'switch',
              label: 'Switch 开关'
            }, {
              value: 'slider',
              label: 'Slider 滑块'
            }, {
              value: 'time-picker',
              label: 'TimePicker 时间选择器'
            }, {
              value: 'date-picker',
              label: 'DatePicker 日期选择器'
            }, {
              value: 'datetime-picker',
              label: 'DateTimePicker 日期时间选择器'
            }, {
              value: 'upload',
              label: 'Upload 上传'
            }, {
              value: 'rate',
              label: 'Rate 评分'
            }, {
              value: 'form',
              label: 'Form 表单'
            }]
          }, {
            value: 'data',
            label: 'Data',
            children: [{
              value: 'table',
              label: 'Table 表格'
            }, {
              value: 'tag',
              label: 'Tag 标签'
            }, {
              value: 'progress',
              label: 'Progress 进度条'
            }, {
              value: 'tree',
              label: 'Tree 树形控件'
            }, {
              value: 'pagination',
              label: 'Pagination 分页'
            }, {
              value: 'badge',
              label: 'Badge 标记'
            }]
          }, {
            value: 'notice',
            label: 'Notice',
            children: [{
              value: 'alert',
              label: 'Alert 警告'
            }, {
              value: 'loading',
              label: 'Loading 加载'
            }, {
              value: 'message',
              label: 'Message 消息提示'
            }, {
              value: 'message-box',
              label: 'MessageBox 弹框'
            }, {
              value: 'notification',
              label: 'Notification 通知'
            }]
          }, {
            value: 'navigation',
            label: 'Navigation',
            children: [{
              value: 'menu',
              label: 'NavMenu 导航菜单'
            }, {
              value: 'tabs',
              label: 'Tabs 标签页'
            }, {
              value: 'breadcrumb',
              label: 'Breadcrumb 面包屑'
            }, {
              value: 'dropdown',
              label: 'Dropdown 下拉菜单'
            }, {
              value: 'steps',
              label: 'Steps 步骤条'
            }]
          }, {
            value: 'others',
            label: 'Others',
            children: [{
              value: 'dialog',
              label: 'Dialog 对话框'
            }, {
              value: 'tooltip',
              label: 'Tooltip 文字提示'
            }, {
              value: 'popover',
              label: 'Popover 弹出框'
            }, {
              value: 'card',
              label: 'Card 卡片'
            }, {
              value: 'carousel',
              label: 'Carousel 走马灯'
            }, {
              value: 'collapse',
              label: 'Collapse 折叠面板'
            }]
          }]
        }, {
          value: 'ziyuan',
          label: '资源',
          children: [{
            value: 'axure',
            label: 'Axure Components'
          }, {
            value: 'sketch',
            label: 'Sketch Templates'
          }, {
            value: 'jiaohu',
            label: '组件交互文档'
          }]
        }]
      };
    },
    methods: {
      handleChange(value) {
        console.log(value);
      },
       handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }
    }
  };
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.storeName{
    width: 30%;
    margin-right: 60%;
}

.clickAddress{
    margin-right: 76%;
}

.textaddress{
    width: 30%;
    margin-right: 61%;
}

.storeTel{
    width: 10%;
}

.storePhone{
    width: 20%;
}

.remark{
    margin-right: 37%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .storeImg{
      margin-right: 70%;
  }

  .storeAptitude{
       margin-right: 90%;
  }

  .storeRemark{
      margin-right: 40%;
  }

  .storeRules{
      margin-right: 70%;
  }

  .storeButton{
      margin-top: 1%;
      margin-right: 80%;
  }

  .storeInfo{
      margin-right: 92%;
  }

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/store/storeAdd.vue